import { PickersCalendarHeader } from "@mui/x-date-pickers";
import { IconButton, styled } from "@mui/material";

export const StyledPickersCalendarHeader = styled(PickersCalendarHeader, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{
  isSelected?: boolean;
}>`
  margin: ${({
    theme: {
      wsc: { spacing },
    },
  }) => `${spacing[3]} ${spacing[2]} ${spacing[2]} ${spacing[2]}`};
  padding: 0;
  min-height: auto;

  .MuiPickersCalendarHeader-labelContainer {
    border-radius: ${(props) => props.theme.wsc.radius.m};
    background-color: ${(props) =>
      props.isSelected
        ? props.theme.wsc.palette.neutral[500]
        : props.theme.wsc.palette.neutral[700]};
    padding: ${({
      theme: {
        wsc: { spacing },
      },
    }) => `${spacing[0]} ${spacing[0]} ${spacing[0]} ${spacing[2]}`};

    &:hover {
      background-color: ${(props) =>
        !props.isSelected && props.theme.wsc.palette.neutral[600]};
    }

    ${(props) =>
      props.isSelected &&
      `
			.MuiSvgIcon-root {
				transform: rotate(180deg);
				fill: ${props.theme.wsc.palette.primary[500]};
			}
		`}
  }

  .MuiPickersCalendarHeader-label {
    ${(props) => props.theme.wsc.typography.body1bold};
    color: ${(props) =>
      props.isSelected
        ? props.theme.wsc.palette.primary[500]
        : props.theme.wsc.palette.neutral[100]};
  }

  .MuiPickersArrowSwitcher-spacer {
    width: ${(props) => props.theme.wsc.size.xxl};
  }
`;

export const StyledPickersCalendarHeaderIconButton = styled(IconButton)`
  padding: 0;

  &:hover {
    background: none;
  }

  .MuiSvgIcon-root {
    width: ${(props) => props.theme.wsc.size.l};
    height: ${(props) => props.theme.wsc.size.l};
    fill: ${(props) => props.theme.wsc.palette.neutral[100]};
  }

  &.Mui-disabled .MuiSvgIcon-root {
    fill: ${(props) => props.theme.wsc.palette.neutral[400]};
  }
`;

export const StyledPickersCalendarHeaderNavIconButton = styled(
  StyledPickersCalendarHeaderIconButton,
)`
  &:hover {
    background: ${(props) => props.theme.wsc.palette.neutral[400]};
  }
`;
